import { Col, Row } from 'reactstrap';
import { useQuery } from 'react-query';
import useGetTopArticles from '../../api/useGetTopArticles';
import DisplayQueryError from '../shared/DisplayQueryError';
import LoadingSpinner from '../shared/LoadingSpinner';
import { Link } from 'react-router-dom';

const PopularArticles = () => {
    const getTopArticles = useGetTopArticles();

    const {
        data: articles,
        isLoading,
        error,
        refetch
    } = useQuery('topArticles', getTopArticles);

    if (error) {
        return <DisplayQueryError error={error} refetch={refetch} />;
    }

    if (isLoading || !articles) {
        return <LoadingSpinner />;
    }

    return (
        <div className='custom-card mt-4'>
            <div className='custom-card-head'>
                <div className='custom-card-heading d-flex align-items-center'>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 512 512'
                        className='custom-card-icon me-2'
                    >
                        <defs>
                            <linearGradient
                                id='linear-gradient'
                                y1='-0.14'
                                x2='1.037'
                                y2='1.226'
                                gradientUnits='objectBoundingBox'
                            >
                                <stop
                                    offset='0'
                                    stopColor='var(--bs-primary)'
                                />
                                <stop
                                    offset='1'
                                    stopColor='var(--bs-primary-light)'
                                />
                            </linearGradient>
                        </defs>
                        <path
                            fill='url(#linear-gradient)'
                            d='M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm0 184c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM160 400c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z'
                        />
                    </svg>
                    <h3 className='mb-0'>Popular articles</h3>
                </div>
            </div>
            <div className='custom-card-body mt-3'>
                <Row>
                    {articles.map((article) => (
                        <Col
                            key={article.slug}
                            xs='12'
                            lg='6'
                            className='question-link-holder'
                        >
                            <Link
                                to={`/article/${article.slug}`}
                                className='question-link'
                            >
                                {article.title}
                            </Link>
                        </Col>
                    ))}
                </Row>
                <Row>
                    <Col xs='12' className='d-flex justify-content-end mt-3'>
                        <Link to='/articles'>View more...</Link>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default PopularArticles;
